/**
 * Rarity / spotlight highlights for entity slot borders, list badges, and equip chrome.
 * Shared between `@repo/ui` equip slots and the web entity-viewer.
 *
 * Colour SSoT: {@link ./rarity-tier-colors}.
 */
export {
	type EntityItemHighlight,
	entityHighlightBorderBackground,
	entityHighlightBorderBeamColors,
} from "./rarity-tier-colors";
